var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isLoading
    ? _c(
        "wa-page-focused",
        [_c("wa-page-loading", { attrs: { slot: "card" }, slot: "card" })],
        1
      )
    : _vm.skuNotFound
    ? _c("not-found-view")
    : _vm.currentOrder
    ? _c("success-view", {
        attrs: {
          slot: "content",
          "current-product": _vm.product,
          "product-sku": _vm.productSku,
          "is-new-account": _vm.isNewAccount,
          theme: _vm.theme,
        },
        slot: "content",
      })
    : _c(
        "wa-page-purchase",
        { attrs: { type: "commission" } },
        [
          _c("wa-page-header-limited", {
            key: "header",
            attrs: {
              slot: "page-header",
              title: _vm.pageTitle,
              "is-showing-cancel": "",
            },
            slot: "page-header",
          }),
          _vm._v(" "),
          _c(
            "template",
            { slot: "purchase-product" },
            [
              _vm.product.sku === "CI-SINGLE"
                ? _c("commission-card", {
                    attrs: {
                      theme: _vm.theme,
                      avatar: "faSquare",
                      cost: 300,
                      description:
                        "Add that single icon you've always wanted in all of Font Awesome's styles.",
                      "icon-count": 1,
                      type: "icon",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.product.sku === "CI-SIXPACK"
                ? _c("commission-card", {
                    attrs: {
                      theme: _vm.theme,
                      avatar: "faGrip",
                      cost: 1500,
                      description:
                        "Just say the magic word, and six icons of your choice will appear in all of our styles.",
                      "icon-count": 6,
                      type: "icon",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.product.sku === "CI-CASE24"
                ? _c("commission-card", {
                    attrs: {
                      theme: _vm.theme,
                      avatar: "faGrid5",
                      cost: 4800,
                      description:
                        "Your wish is our command — add twenty-four icons of your choice in all of our styles.",
                      "icon-count": 24,
                      type: "icon",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.product.sku === "CI-BRAND"
                ? _c("commission-card", {
                    attrs: {
                      theme: _vm.theme,
                      avatar: "faStar",
                      cost: 3000,
                      description:
                        "Make your brand's existing logo known and accessible to millions of users by adding it to Font Awesome Free.",
                      "icon-count": 1,
                      type: "logo",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("purchase-form", {
            attrs: {
              slot: "purchase-flow",
              theme: _vm.theme,
              "total-cents": _vm.totalCents,
              "billing-description": _vm.billingDescription,
              "current-product": _vm.product,
            },
            slot: "purchase-flow",
          }),
          _vm._v(" "),
          _c("commission-faqs", {
            attrs: { slot: "purchase-support" },
            slot: "purchase-support",
          }),
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }